module.exports = __webpack_public_path__ + "static/banner-assurances-mobile-bf99f2fc65431d3c19fb72f8d735f1ea.jpg";